/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationsControllerRemoveMutationResponse, WorkflowApplicationsControllerRemovePathParams, WorkflowApplicationsControllerRemove401, WorkflowApplicationsControllerRemove403, WorkflowApplicationsControllerRemove404 } from "../../models/workflowsController/WorkflowApplicationsControllerRemove";

function getWorkflowApplicationsControllerRemoveUrl(id: WorkflowApplicationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/workflow-applications/${id}` as const }  
  return res
}

/**
 * @summary Soft-delete a workflow application
 * {@link /api/v1/workflow-applications/:id}
 */
export async function workflowApplicationsControllerRemove(id: WorkflowApplicationsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowApplicationsControllerRemoveMutationResponse, ResponseErrorConfig<WorkflowApplicationsControllerRemove401 | WorkflowApplicationsControllerRemove403 | WorkflowApplicationsControllerRemove404>, unknown>({ method : "DELETE", url : getWorkflowApplicationsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}